//from dojox gfx.canvas:
var dasharray = {
	solid: "none",
	shortdash: [4, 1],
	shortdot: [1, 1],
	shortdashdot: [4, 1, 1, 1],
	shortdashdotdot: [4, 1, 1, 1, 1, 1],
	dot: [1, 3],
	dash: [4, 3],
	longdash: [8, 3],
	dashdot: [4, 3, 1, 3],
	longdashdot: [8, 3, 1, 3],
	longdashdotdot: [8, 3, 1, 3, 1, 3]
};

export = dasharray;